import React from "react";
import { CommunicationSetting } from "./communication/CommunicationSetting";

export default function Communication() {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold tracking-tight">Communication</h1>
          <p className="text-muted-foreground">
            Manage communication settings
          </p>
        </div>
      </div>

      <div className="space-y-6">
        <CommunicationSetting />
      </div>
    </div>
  );
}
